import CountChartRepository from '@src/repositories/CountChartRepository';

class CountChartService {
  constructor() {
    this.countChartRepository = new CountChartRepository();
  }

  async createCountChart({ data, orgId, divId = null, boardId }) {
    return this.countChartRepository.create({ data, orgId, divId, boardId });
  }

  async updateCountChart({ data, orgId, divId = null, boardId, chartId }) {
    return this.countChartRepository.update({ data, orgId, divId, boardId, chartId });
  }

  async getCountChart({ orgId, divId = null, boardId, chartId }) {
    return this.countChartRepository.get({ orgId, divId, boardId, chartId });
  }
}

export default CountChartService;
